import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';
import { Types } from './types';

// ACTIONS
import {
	IRequestPesquisaCriminal,
	consultaPesquisaCriminalSuccess,
	consultaPesquisaCriminalFailure,
} from './actions';

function* consultaPesquisaCriminalRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IRequestPesquisaCriminal } = request;
	const { usuario, ...params } = payload;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'emissao/criminal',
		params,
		undefined,
		undefined,
		undefined,
		usuario,
		undefined,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaPesquisaCriminalSuccess(response.data.pessoa ?? []));
	} else if (response.error) {
		yield put(consultaPesquisaCriminalFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PESQUISA_CRIMINAL_REQUEST,
		consultaPesquisaCriminalRequest,
	),
]);
